/**
 * Which way a key is written on screen.
 *
 * The two notations are the same fact for different jobs. `8A` is arithmetic:
 * adjacency on the Camelot wheel is what says two records will mix, and a DJ
 * reads it without converting anything. `A minor` is what goes in a rota, gets
 * said out loud to a musician, and matches what a score would tell you. Nova
 * used to print both side by side plus two runner-up codes, which made the
 * busiest column in the grid four values wide and none of them the answer.
 *
 * So it shows one, and this is the switch. A per-viewer display preference like
 * the theme rather than a library setting: two curators can disagree about
 * notation without either of them changing what the other sees, because nothing
 * about the data changes — only how it is spelled.
 */

export type KeyNotation = "camelot" | "musical";

const STORAGE_KEY = "nova.keyNotation";

export function readNotation(): KeyNotation {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "camelot" || raw === "musical") return raw;
  } catch {
    // Private mode or blocked storage. The default is a fine answer.
  }
  return "camelot";
}

export function storeNotation(choice: KeyNotation): void {
  try {
    localStorage.setItem(STORAGE_KEY, choice);
  } catch {
    // Not worth surfacing: the choice still applies for this session.
  }
}
